export default "__VITE_ASSET__FDAznp_T__"